'use client';

import * as React from 'react';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useTRPC } from '@/trpc/client';
import { latestQueryOptions } from '@/lib/queries/articleQueries';
import Carousel from '@/components/ui/Carousel';
import CarouselPost from '@/components/ui/Carousel/Post';
import Buttons from '@/components/ui/Buttons';
import Button from '@/components/ui/Button';
import { getLocalizedPath } from '@/components/helpers/localize';
import { Locale } from '@/lib/enums/locale.enum';
import QueryErrorState from '@/components/fallback/QueryErrorState';

const LatestBlogArticles: React.FunctionComponent = () => {
  const { t, i18n } = useTranslation();
  const trpc = useTRPC();
  const query = useQuery(latestQueryOptions({ trpc }));
  const { data } = query;
  const latestArticles = data?.articles ?? [];
  const path = getLocalizedPath('blog', 'blog', i18n.language as Locale);

  if (query.isError) {
    return <QueryErrorState error={query.error} />;
  }

  return (
    <React.Fragment>
      <Carousel
        level="h2"
        title={t('components.blog.title')}
        layout="blog"
      >
        {latestArticles.map((article) => (
          <CarouselPost
            key={article.id}
            id={article.id}
            image={article.image}
            headline={article.headlinePlain}
            url={article.permalink}
          />
        ))}
      </Carousel>

      <Buttons layout="centered">
        <Button
          title={t('components.blog.button')}
          size="large"
          href={path}
        />
      </Buttons>
    </React.Fragment>
  );
};

export default LatestBlogArticles;
